/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  console.log('Custom JS');

  $('input[name="selling_plan"]').click(function(){
    setTimeout(function() { 
      $('span.product__price--off').removeClass('hide');
    }, 200);
    if($(this).val() == '817135797'){
      $('.product__selectors input[type="radio"]').eq(1).prop('checked',true);
    }else{
      $('.product__selectors input[type="radio"]').eq(0).prop('checked',true);
    }
  });

  $('input[name="selling-plan-group"]').click(function(){
    console.log($(this).val());
    if($(this).val() != ''){
      $('.product__selectors input[type="radio"]').eq(0).prop('checked',true);
      $('.product__selectors').css('pointer-events','none');
    }else{
      $('.product__selectors').css('pointer-events','auto');
    }
  });
  

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
